module.exports = __webpack_public_path__ + "img/deduction_under_80CD.186a55dc.svg";